import {Injectable} from '@angular/core';
import {DATA_TYPE} from '@constants/data-type.constant';
import {DateService} from '@services/date.service';
import {DecimalPipe} from '@angular/common';
import {USER_ROLE, USER_ROLES_PRIORITIES} from '@constants/user-role.constant';
import { TranslationService } from '@services/translation/translation.service';

@Injectable({
  providedIn: 'root'
})
export class UtilsService {
  constructor(
      private dateService: DateService,
      private decimalPipe: DecimalPipe,
      private translationService: TranslationService) {
  }

  public isAdminOrHigher(isAdminRole: boolean, isTechAdminRole: boolean, isSuperAdminRole: boolean) {
    return isAdminRole || isTechAdminRole || isSuperAdminRole;
  }

  public isHigherThanAdmin(isTechAdminRole: boolean, isSuperAdminRole: boolean) {
    return isTechAdminRole || isSuperAdminRole;
  }

  public getObjectDeepCopy<T>(object: T): T {
    const clone = JSON.parse(JSON.stringify(object));
    return clone as T;
  }

  public parseSignalValue(type, value, precision) {
    if (!precision) {
      precision = 0;
    }
    switch (type) {
      case DATA_TYPE.TIMESTAMP: {
        return String(this.dateService.getMediumTime(value));
      }
      case DATA_TYPE.BOOLEAN:
      case DATA_TYPE.BOOL:
      case DATA_TYPE.STRING: {
        return value;
      }
      case DATA_TYPE.INTEGER:
      case DATA_TYPE.INT16:
      case DATA_TYPE.UINT16:
      case DATA_TYPE.INT32:
      case DATA_TYPE.UINT32:
      case DATA_TYPE.INT64:
      case DATA_TYPE.FLOAT:
      case DATA_TYPE.FLOAT64: {
        return String(this.decimalPipe.transform(Number(value), '1.' + precision + '-' + precision, this.translationService.getActiveLanguage()));
      }
      default:
        return value;
    }
  }

  public isFirstRoleHigherOrEqualThanSecond(roleOne: USER_ROLE | string, roleTwo: USER_ROLE | string): boolean {
    return USER_ROLES_PRIORITIES[roleOne] <= USER_ROLES_PRIORITIES[roleTwo];
  }

  public generateUniqueId(): string {
    return Math.random().toString(36).substring(2);
  }

  public isNumeric(value: any): boolean {
    return !isNaN(parseFloat(value)) && typeof value === 'number';
  }
}
